export default __webpack_public_path__ + "static/media/court-3.5b36686a.png";